<div class="five-star-rating" [ngClass]="invalid && !_value ? 'error-color' : 'normal-color'">
  <div class="cell small-12 medium-12 large-12 question-label">{{label}}</div>
  <div class="radio-buttons grid-x grid-padding-x">
    <div class="radio-side-label cell shrink"><span>{{lowScoreLabel}}</span></div>
    <div class="score-div cell shrink">
      <mat-radio-group>
        <mat-radio-button (change)="radioSelected($event)" value="1">1</mat-radio-button>
        <mat-radio-button (change)="radioSelected($event)" value="2">2</mat-radio-button>
        <mat-radio-button (change)="radioSelected($event)" value="3">3</mat-radio-button>
        <mat-radio-button (change)="radioSelected($event)" value="4">4</mat-radio-button>
        <mat-radio-button (change)="radioSelected($event)" value="5" class="last-radio">5</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="radio-side-label cell shrink"><span>{{highScoreLabel}}</span></div>
  </div>
</div>
